import React, { useState } from 'react';
import './styles.scss';

const FileUpload = ({ fileFormat, setUploadedFile, selectedFile, setSelectedFile, setEmptyFileError }) => {
    const [,] = useState(null);
    const [fileSize, setFileSize] = useState(0);

    const handleClearFile = () => {
        setSelectedFile(null);
        setEmptyFileError(null);
        document.getElementById('file-upload').value = '';
    };



    function fileUploaded(e) {
        setSelectedFile(e.target.files[0]);
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        if (file) {
            setFileSize(e.target.files[0].size);
        } else {
            setFileSize('');
        }
        // console.log(e.target.files[0].size)
        setUploadedFile(formData);
    }

    return (
        <>
            <div className="custom-upload-btn-block">
                <label for="file-upload" className="custom-upload-btn">Choose File</label>
                <input type={"file"} id="file-upload" accept={fileFormat} onChange={(e) => { fileUploaded(e) }} placeholder='No file selected' />

                {!selectedFile &&
                    <span className="selected-file-name-disabled" 
                    onDragOver={e => e.preventDefault()}
                    onDragEnter={e => e.preventDefault()}
                    >No file selected</span>
                }

                {selectedFile &&
                    <span className="selected-file-name">{selectedFile.name}</span>
                }
                <span className="clear-file"><span className="closebtn" onClick={handleClearFile}>&nbsp;</span></span>
            </div>
            <span className="text-small">CSV format, up to 10 MB</span><br />
            {fileSize > 10000000 && <span className="text-small red">Filesize should be lessthan 10 MB</span>}
        </>
    );
};

export default FileUpload;
